import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Lottie from "lottie-react"; // Ensure this path is correct
import animationData from "../component/assets/loader-logo.json";
import { FiArrowUpRight } from "react-icons/fi";

export const ProjectDetailPage = () => {
  const { slug, id } = useParams(); // 🟡 documentId from URL
  const [data, setData] = useState(null);
  const [suggests, setSuggests] = useState([]);
  const navigate = useNavigate();
  let lastScrollY = window.scrollY;

  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    // ✅ Use new variable
    let apiSlug = slug;
    if (slug === "uiux") {
      apiSlug = "portolio-uixifies";
    } else if (slug === "logobranding") {
      apiSlug = "logo-and-branding-uixifies";
    } else if (slug === "animation") {
      apiSlug = "animation-uixifies";
    }
    console.log("slu", apiSlug);
    axios
      .get(
        `https://brilliant-family-61fde61fa1.strapiapp.com/api/${apiSlug}/${id}?populate=*`
      )
      .then((res) => {
        const fetchedData = res.data.data;
        setData(fetchedData);

        const slug = fetchedData?.slug;
        const documentId = fetchedData?.documentId || fetchedData.id;

        let url = "";
        if (slug === "uiux") {
          url =
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/portolio-uixifies?populate=image";
        } else if (slug === "logobranding") {
          url =
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/logo-and-branding-uixifies?populate=image";
        } else if (slug === "animation") {
          url =
            "https://brilliant-family-61fde61fa1.strapiapp.com/api/animation-uixifies?populate=image";
        }

        if (url) {
          axios
            .get(url)
            .then((response) => {
              const all = response.data.data.filter((item) => {
                const itemId = item?.documentId || item?.id;
                return itemId !== documentId;
              });

              const shuffled = all.sort(() => 0.5 - Math.random());
              setSuggests(shuffled.slice(0, 3));
            })
            .catch((err) => console.error("Suggestions fetch error:", err));
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  }, [id]);

  if (!data)
    return (
      <div className="flex justify-center items-center h-screen bg-[#7366fc]">
        <Lottie
          animationData={animationData}
          loop={true}
          style={{ width: 150, height: 150 }}
        />
      </div>
    );

  const attr = data;
  const img = data?.image?.url;
  const imageUrl = img?.startsWith("http")
    ? img
    : `https://brilliant-family-61fde61fa1.strapiapp.com${img}`;

  const scrollToSection = (id) => {
    // First navigate to home page
    navigate("/");

    // Then scroll to the section after a small delay to allow page transition
    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <div className="bg-[#7366fc] pt-10 max-[2000px]:pt-[10vh] pb-4">
      <div className="container mx-auto px-4 pt-4 md:pt-8 md:pt-14">
        <h1 className="capitalize text-white text-[25px] md:text-[65px] leading-normal md:leading-[40px] mt-6 md:mt-10 font-black tracking-wide  size-fit ">
          {attr?.title}
        </h1>
        <div className="my-8 md:my-12">
          <img
            src={imageUrl}
            alt="Project Detail"
            className="w-full h-auto rounded-[15px]"
          />
        </div>
        <div className="grid md:grid-cols-4 grid-cols-2 gap-3 my-6 ">
          {attr?.year && (
            <div className="text-white p-4 rounded-lg ">
              <h5 className="text-2xl text-[#c0ff00] font-black">Year</h5>
              <p className=""> {attr?.year}</p>
            </div>
          )}
          {attr?.Industry && (
            <div className="text-white p-4 rounded-lg ">
              <h5 className="text-2xl text-[#c0ff00] font-black">Industry</h5>
              <p className=""> {attr?.Industry}</p>
            </div>
          )}
          {attr?.ProjectScope && (
            <div className="text-white p-4 rounded-lg ">
              <h5 className="text-2xl text-[#c0ff00] font-black">
                Project Scope
              </h5>
              <p className="">{attr?.ProjectScope}</p>
            </div>
          )}
        </div>
        {/* About Section */}
        {attr?.AboutHeading && (
          <div className="grid md:grid-cols-2 grid-cols-1 gap-3 md:gap-12 my-6 md:mt-12 md:mb-12">
            <h4 className="text-white text-6xl">{attr.AboutHeading}</h4>
            <p className="text-white text-xl">{attr.AboutDescription}</p>
            {attr?.AboutImage?.url && (
              <img
                src={attr?.AboutImage?.url}
                alt="About Image"
                className="w-full h-auto md:col-span-2 md:mb-12 rounded-[15px]"
              />
            )}
          </div>
        )}

        {/* Brand Identity Section */}
        {attr?.BrandIdentityTitle && (
          <>
            <h4 className="text-white mt-12 text-4xl">
              {attr.BrandIdentityTitle}
            </h4>
            <p className="text-white text-xl  mt-4">
              {attr.BrandIdentityDescription}
            </p>

            {attr?.BrandIdentityImages?.length > 0 && (
              <div className="col-span-2 grid md:grid-cols-2 grid-cols-1 gap-3 md:gap-12">
                {attr.BrandIdentityImages.map((image, index) => {
                  const imgUrl = image?.url ? image?.url : "";
                  return (
                    <img
                      key={image.id || index}
                      src={imgUrl}
                      alt={
                        image.alternativeText ||
                        `Brand Identity Image ${index + 1}`
                      }
                      className="w-full h-auto  mt-6 rounded-[15px]"
                    />
                  );
                })}
              </div>
            )}
          </>
        )}

        {/* Our Approach Section */}
        {attr?.OurApproachHeading && (
          <>
            <div className="md:w-[70%] md:mt-12">
              <h3 className="text-white text-4xl font-bold mt-12">
                {attr.OurApproachHeading}
              </h3>
              <p className="text-white text-xl mt-4">
                {attr.OurApproachDescription}
              </p>
            </div>
            {attr?.OurApproachImage?.url && (
              <img
                src={attr.OurApproachImage.url}
                alt="Our Approach Image"
                className="w-full h-auto mt-6 rounded-[15px]"
              />
            )}
          </>
        )}
        <div className="flex justify-between item-end mt-12 md:mt-14 ">
          <h2 className="text-white text-4xl font-bold ">Other Projects</h2>
          <a
            onClick={() => scrollToSection("blogs")}
            className="w-fit h-fit uppercase text-[12px] md:text-[17px] bg-[#c0ff00] hover:scale-105 px-8 py-2 rounded-full flex gap-2 border border-black border-b-4 font-semibold"
          >
            See All Projects
            <FiArrowUpRight className="scale-105 m-auto text-black" />
          </a>
        </div>
        <div className="grid md:grid-cols-3 grid-cols-1 gap-3 my-5 px-4 md:px-0 pb-14 bg-[#7366fc]">
          {suggests.map((item) => {
            const attr = item;
            const imgUrl = item?.image?.url;
            const imageSrc = imgUrl?.startsWith("http")
              ? imgUrl
              : `https://brilliant-family-61fde61fa1.strapiapp.com${imgUrl}`;

            const currentId = data?.documentId || data?.id;
            const suggestionId = item?.documentId || item?.id;

            // 💡 Skip same project if it appears accidentally
            if (suggestionId === currentId) return null;

            return (
              <div key={item.id} className="w-full">
                {imgUrl ? (
                  <div className="relative group w-full overflow-hidden rounded-[15px]">
                    <img
                      src={imageSrc}
                      alt={attr?.title || "Logo"}
                      className="object-contain w-full transition-transform duration-300 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black bg-opacity-60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 p-4">
                      <div className="flex items-center justify-center h-full w-full">
                        <Link
                          to={`/project/${attr?.slug}/${suggestionId}`}
                          rel="noopener noreferrer"
                          className="uppercase text-[8px] md:text-[12px] text-white hover:scale-105 px-4 py-2 rounded-full flex gap-2 border-2 border-white  font-semibold bg-transparent  transition-colors"
                        >
                          View Project
                        </Link>
                      </div>
                      <div className="absolute left-4 bottom-4 text-white text-lg font-semibold capitalize">
                        {attr?.title || "Untitled"}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="bg-gray-200 w-full h-48 flex items-center justify-center">
                    No image
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
